
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { AppConfigService } from 'src/core/services/appconfig.service';
import { BusinessPartnerAccessService } from 'src/core/services/business-partner-access.service';
import { ModalService } from 'src/core/services/modal.service';
import { environment } from 'src/environments/environment';

const HELP_MODULE_TRANSLATION_KEYS: Record<string, string> = {
  'System Health': 'helpModal.moduleNames.systemHealth',
  'Service Metrics': 'helpModal.moduleNames.serviceMetrics',
  'Service History': 'helpModal.moduleNames.serviceHistory',
  'Functional Location Overview': 'helpModal.moduleNames.functionalLocationOverview',
  'Upcoming-Services-Gen': 'helpModal.moduleNames.upcomingServices',
  'Autocheck': 'helpModal.moduleNames.autocheck',
  'Maintenance': 'helpModal.moduleNames.maintenance',
  'Proactive Alarms': 'helpModal.moduleNames.proactiveAlarms',
  'QC': 'helpModal.moduleNames.qc',
  'Events': 'helpModal.moduleNames.events',
  'Notifications': 'helpModal.moduleNames.notifications',
  'Spare Parts Used': 'helpModal.moduleNames.sparePartsUsed',
  'Site Visits': 'helpModal.moduleNames.siteVisits',
  'Escalations': 'helpModal.moduleNames.escalations',
  'CDI': 'helpModal.cdi.title',
  'CI': 'helpModal.ci.title',
  'Functional Location': 'helpModal.moduleNames.functionalLocation',
  'Upcoming-Services': 'helpModal.moduleNames.upcomingServices',
};
const FEEDBACK_TICKETING_URL = 'https://healthcare.service-now.com/serviceport?id=sc_cat_item&sys_id=906528a10a0a0bf000a85bc20dfb6541&sysparm_variables=%7B%22create_ticket%22:%22true%22,%22search_for_service%22:%22cd02500e83cfded0eb92bcdfeeaad3c2%22,%22cmdb_ci%22:%22468a405ec3d8aa101bde1673e401318e%22,%22ticket_classification%22:%225%22%7D';
const FEEDBACK_MAILTO_URL = 'mailto:dx_axis.func@siemens-healthineers.com?subject=AXIS%20Feedback';

@Component({
  selector: 'app-help-modal',
  imports: [TranslocoModule],
  templateUrl: './help-modal.component.html',
  styleUrl: './help-modal.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HelpModalComponent {
  releaseNotes: any[] | null = null;

  constructor(
    private modalService: ModalService,
    private appConfigService: AppConfigService,
    private bpAccessService: BusinessPartnerAccessService,
    private translocoService: TranslocoService
  ) {}

  selectedHelpModule: string = '';

  get bpCanMachineData(): boolean {
    return this.bpAccessService.canViewMachineData;
  }

  get bpCanServiceData(): boolean {
    return this.bpAccessService.canViewServiceData;
  }

  get translatedSelectedHelpModule(): string {
    const translationKey = HELP_MODULE_TRANSLATION_KEYS[this.selectedHelpModule];

    return translationKey
      ? this.translocoService.translate(translationKey)
      : this.selectedHelpModule;
  }

  get functionalLocationSuccessText(): string {
    if (this.bpCanMachineData && this.bpCanServiceData) {
      return this.translocoService.translate('helpModal.funcLoc.success.both');
    }

    if (this.bpCanMachineData) {
      return this.translocoService.translate('helpModal.funcLoc.success.machineOnly');
    }

    if (this.bpCanServiceData) {
      return this.translocoService.translate('helpModal.funcLoc.success.serviceOnly');
    }

    return this.translocoService.translate('helpModal.funcLoc.success.none');
  }

  get functionalLocationWarningText(): string {
    if (this.bpCanMachineData && this.bpCanServiceData) {
      return this.translocoService.translate('helpModal.funcLoc.warning.both');
    }

    if (this.bpCanMachineData) {
      return this.translocoService.translate('helpModal.funcLoc.warning.machineOnly');
    }

    if (this.bpCanServiceData) {
      return this.translocoService.translate('helpModal.funcLoc.warning.serviceOnly');
    }

    return this.translocoService.translate('helpModal.funcLoc.warning.none');
  }

  get functionalLocationErrorText(): string {
    if (!this.bpCanServiceData) {
      return this.translocoService.translate('helpModal.funcLoc.error.noService');
    }

    return this.translocoService.translate('helpModal.funcLoc.error.totallyDown');
  }

  get feedbackText2Key(): string {
    return environment.businessPartnerMode ? 'helpModal.feedback.text2External' : 'helpModal.feedback.text2';
  }

  get feedbackButtonKey(): string {
    return environment.businessPartnerMode ? 'helpModal.feedback.buttonExternal' : 'helpModal.feedback.button';
  }

  get feedbackUrl(): string {
    return environment.businessPartnerMode ? FEEDBACK_MAILTO_URL : FEEDBACK_TICKETING_URL;
  }

  ngOnInit(): void {
    // Subscribe to the release notes observable (note the $ suffix)
    this.appConfigService.releaseNotes$.subscribe((notes) => {
      console.log('[HelpModal] Release notes updated:', notes);
      this.releaseNotes = notes;
    });

    this.modalService.$helpModalChanged.subscribe((modal) => {
      if (modal && modal.open === true) {
        this.selectedHelpModule = modal.modal;
      }
    });
  }

  openURL = (URL, event: Event) => {
    event.stopPropagation();
    window.open(URL, "_blank");
  }
}
